<div class="map-toolbar-group" *ngIf="(isMapLoading$ | async) === false">
  <div class="btn-toolbar btn-group-vertical shadow rounded bg-white">
    <button
      class="btn btn-reverse-dark btn-icon-only border-0"
      (click)="zoomIn()"
      title="Zoom In"
    >
      <i class="modus-icons">add</i>
    </button>
    <button
      class="btn btn-reverse-dark btn-icon-only panel-button"
      (click)="zoomOut()"
      title="Zoom Out"
    >
      <i class="modus-icons">remove</i>
    </button>
    <app-next-previous-view></app-next-previous-view>
    <button
      class="btn btn-reverse-dark btn-icon-only panel-button border-0"
      (click)="printMap()"
      title="Print Map"
    >
      <i class="modus-icons">
        <img src="../assets/img/icons/print.svg" />
      </i>
    </button>
  </div>
</div>
